/**
 * @description Navigate transition animation with 'none' fill mode (i.e. no animation)
 */
export default function noneTransitionAnimation() {
  return createAnimation('none-animation').fill('none').duration(10)
}
